import React from 'react';
import styled from "styled-components";

const IconPwaTextBox = styled.span`
    color: var(--it-text-white);
		
    text-align: center;
    font-family: "Druk Wide";
    font-size: 8px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 9.6px */
    letter-spacing: 0.24px;
    text-transform: uppercase;

		&[data-blue] {
        color: var(--it-accent-blue);
		}
`
export const IconPwaText = ({style = {}, ...rest}) => {
	return (
		<IconPwaTextBox
			style={style}
			{...rest}
		>
			PWA
		</IconPwaTextBox>
	)
}